export default __webpack_public_path__ + "static/media/pont.5a52231d.png";